export const goodType = (type)=>{
    let str = "";
    switch(type){
       case 1:
          str = "海运";
          break;
       case 2:
          str = "海运大件";
          break;
       case 3:
          str = "空运";
          break;   
    }
    return str;
}

export const orderStatus = (status)=>{
   let str = "";
   switch(status){
      case 1:
         str = "待入库";
         break;
      case 2:
         str = "已入库";
         break;
      case 3:
         str = "已出库";
         break;
      case 4:
         str = "已结单";
         break;  
      case -1:
         str = "已取消";
         break; 
      case 7:
         str = "（分拨）已入库";
         break; 
      case 8:
         str = "（分拨）已出库";
         break; 
      case 9:
         str = "（派送）已入库";
         break;                             
   }
   return str;
}




// WEBPACK FOOTER //
// ./src/utils/StringUtils.js